export const addMessageSelector = (state) => state.addMessage.message
